import cn from 'classnames';
import styles from './Contest.module.scss';
import {useMediaQuery} from 'react-responsive';
import {useCookies} from 'react-cookie';
import {Voting} from "../Voting/Voting";

const text = [
    {
        id: 1,
        info: "Проголосуй за самую дикую историю",
        list: ["1. Выбери самый дикий кринж и поставь ему палец вверх"]
    },
    {
        id: 2,
        info: "Проголосовавший получит приятный ништяк",
        list: ["2. Роскошный стикерпак ждёт всех, кто проголосует за одну из историй ниже"]
    },
    {
        id: 3,
        info: "А самую кринжовую историю мы покажем по телевизору",
        list: ["3. Топовость кринжа определяется всеобщим голосованием. Успей сделать свой выбор до 14 октября"]
    }
]

export const Contest = () => {
    const isMobile = useMediaQuery({ query: `(max-width: 1024px)` });
    const [cookie, setCookie] = useCookies(['voting']);

    const rules = text.map(item => {
        return (
            <li key={item.id} className={styles.item}>
                <div className={styles.number}>{item.id}</div>
                <div className={styles.rule}>{item.info}</div>
                {item.list.map((sup, index) => {
                    return (
                        <div key={index} className={styles.sup}>{(item.id === 1 && isMobile) ? '1. Специальное поле для ввода кринжа внизу' : sup}</div>
                    )
                })}
            </li>
        )
    })

    return (
        <div className={styles.contest}>
            <div className={styles.info}>
                <div className={cn("h2", styles.title)}>Как это работает</div>
                <ul className={styles.rules}>
                    {rules}
                </ul>
            </div>
            <Voting cookie={cookie.voting}/>
        </div>
    )
}